import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND;

export default function Footer() {

    const [logos, setLogos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${BACKEND_URL}/api/footer?populate=logos`)
            .then(res => {
                const logoData = res.data.data.logos;
                setLogos(logoData);
                setLoading(false);
            })
            .catch(err => console.error(err));
    }, []);

    return (
        <footer style={{
            padding: "2vh",
            background: "#135597ff",
            textAlign: "center",
            overflow: "hidden",
            zIndex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "4vw",
        }}>
            {logos.map((logo) => (
                <img
                    key={logo.documentId}
                    src={`${logo.url}`}
                    alt={logo.name}
                    style={{
                        height: "clamp(30px, 4vw, 50px)",
                        flexShrink: 0,
                    }}
                />
            ))}
        </footer>
    );

}